import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {Category, CbiService, GenericOption, GenericOptionGroup, WorkType, WorkTypeService} from '@cas-hub/acabim-common-client';
import {CategoryTableData} from '../../work-order.model';
import {CategoryResponse} from '@cas-hub/acabim-common-client/lib/_models/work-type.model';

@Component({
  selector: 'acabim-admin-work-order-category-details',
  templateUrl: './work-order-category-details.component.html',
  styleUrls: ['./work-order-category-details.component.scss']
})
export class WorkOrderCategoryDetailsComponent implements OnInit {

  @Input() set workCategoryData(value: CategoryTableData) {
    this.tabIndex = 0;
    this.showDone = false;
    if (value) {
      this.workCategoryDetails = value;
    }
    this.init();
  }
  @Input() set workTypeData(value: WorkType) {
    this.showDone = false;
    if (value) {
      this.workTypeDetails = value;
      this.handleTypeCbiGroup();
    }
  }
  @Output() completed = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<any>();

  cbiClassOptions: GenericOption[] = [];
  cbiClassOptionsGrouped: GenericOptionGroup[] = [];
  isLoading = false;
  parcel: Category | null = null;
  showDone = false;
  tabIndex = 0;
  viewStatus = 'add';
  workCategoryDetails: CategoryResponse | null = null;
  workTypeDetails: WorkType | null = null;
  editForm: FormGroup = new FormGroup({
    name: new FormControl(),
    cbiClass: new FormControl(),
    defaultPriority: new FormControl(),
    status: new FormControl(),
  });
  priorityOptions: GenericOption[] = [
    {label: 'Low', value: 0},
    {label: 'Medium', value: 1},
    {label: 'High', value: 2},
  ];
  statusOptions: GenericOption[] = [
    {label: 'Active', value: 1},
    {label: 'Archive', value: 0},
  ];

  constructor(
      private readonly cbiService: CbiService,
      private readonly workTypeService: WorkTypeService
  ) { }

  ngOnInit(): void {}

  init(): void {
    this.tabIndex = 0;
    this.isLoading = true;
    this.cbiService.getGrouped().subscribe(groups => {
      groups.map(group => {
        const classes = (group.classes && group.classes.length > 0) ? group.classes : [];
        const tmp: GenericOptionGroup = {
          label: group.name,
          items: classes.map(cl => {
            return {
              label: cl.id.toString() + ' – ' + cl.name,
              value: cl.id
            };
          })
        };
        this.cbiClassOptionsGrouped.push(tmp);
      });
      this.initForm();
    });
  }

  handleTypeCbiGroup(): void {
    if (this.workTypeDetails && this.workTypeDetails.cbi_group) {
      this.cbiService.getGroup(this.workTypeDetails.cbi_group.id).subscribe(cbi => {
        cbi.map(cl => {
          const tmp: GenericOption = {
            label: cl.id.toString() + ' – ' + cl.name,
            value: cl.id
          };
          this.cbiClassOptions.push(tmp);
        });
      });
    }
  }

  initForm(): void {
    if (this.workCategoryDetails && this.editForm) {
      this.editForm.get('name')?.setValue(this.workCategoryDetails.name);
      this.editForm.get('cbiClass')?.setValue(this.workCategoryDetails.cbi_class?.id);
      this.editForm.get('defaultPriority')?.setValue(this.workCategoryDetails.default_priority);
      if (this.workCategoryDetails.status && this.workCategoryDetails.status > 0) {
        this.editForm.get('status')?.setValue(1);
      } else {
        this.editForm.get('status')?.setValue(0);
      }
      this.viewStatus = 'edit';
    }
    this.isLoading = false;
  }

  selectTab(value: any): void {}

  cancel(): void {
    this.tabIndex = 0;
    this.cancelled.emit(false);
  }

  add(): void {
    this.gather();
    if (this.parcel && this.workTypeDetails && this.workTypeDetails.id) {
      this.isLoading = true;
      this.workTypeService.addCategory(this.workTypeDetails.id, this.parcel).subscribe(data => {
        this.isLoading = false;
        this.showDone = true;
      }, error => {
        this.isLoading = false;
      });
      this.resetEditForm();
    }
  }

  resetEditForm(): void {
    if (this.editForm) {
      this.editForm.get('name')?.setValue('');
      this.editForm.get('cbiClass')?.setValue('');
      this.editForm.get('defaultPriority')?.setValue(null);
    }
  }

  close(): void {
    this.completed.emit(true);
    this.tabIndex = 0;
    this.showDone = false;
  }

  update(): void {
    this.gather();
    if(this.parcel && this.workCategoryDetails && this.workCategoryDetails.type_id && this.workCategoryDetails.id) {
      this.isLoading = true;
      this.workTypeService.updateCategory(this.workCategoryDetails.type_id, this.workCategoryDetails.id, this.parcel).subscribe(data => {
        this.isLoading = false;
        this.showDone = true;
      }, error => {
        this.isLoading = false;
      })
    }
  }

  gather(): void {
    if( this.editForm) {
      const workTypeId = this.workTypeDetails && this.workTypeDetails.id ? this.workTypeDetails.id : null;
      this.parcel = {
        name: this.editForm.get('name')?.value,
        default_priority: this.editForm.get('defaultPriority')?.value,
        cbi_class_id: this.editForm.get('cbiClass')?.value,
        status: this.viewStatus === 'add' ? 1 : this.editForm.get('status')?.value
      };
      if(workTypeId) {
        this.parcel.type_id = workTypeId;
      }
    }
  }

} // end of class
